/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestUserSearchModel } from '../model/models';
import { ApiResponseUserSearchModel } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface UserSearchServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestUserSearchModel 
     */
    userSearchControllerSearch0(apiRequestUserSearchModel: ApiRequestUserSearchModel, extraHttpRequestParams?: any): Observable<Array<ApiResponseUserSearchModel>>;

    /**
     * 
     * 
     * @param apiRequestUserSearchModel 
     */
    userSearchControllerSearch1(apiRequestUserSearchModel: ApiRequestUserSearchModel, extraHttpRequestParams?: any): Observable<Array<ApiResponseUserSearchModel>>;

}
